import React from "react";
import { Fab } from "@mui/material";
import Assets from "./Assets";

const IconBackground = ({ icon, size = "36px", bgColor = "#FFF", onClick, disabled = false, sx }) => {
    return (
        <Fab
            onClick={onClick}
            disabled={disabled}
            sx={{
                position: "relative",
                height: size,
                width: size,
                backgroundColor: bgColor,
                minHeight: "30px",
                borderRadius: "50%",
                opacity: disabled ? "50%" : "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: icon === "edit" ? "inset 0px -4px 8px 1px rgba(148, 150, 158, 0.4)" : icon === "delete" ? "inset 0px -4px 8px 1px rgba(239, 68, 68, 0.4)" :  icon === "download" ? "inset 0px -4px 8px 1px rgba(255, 180, 0, 0.4)"  : "inset 0px -4px 8px 1px rgba(231, 120, 67, 0.4)",
                "&::before": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    padding: "1px",
                    borderRadius: "50%",
                    background: icon === "edit" ? "linear-gradient(180deg,rgba(148, 150, 158, 0.5), #94969E)" : icon === "delete" ? "linear-gradient(180deg,rgba(239, 68, 68, 0.5), #EF4444)" : icon === "download" ? "linear-gradient(180deg,rgba(250, 180, 0, 0.5), #FFB400)" :"linear-gradient(180deg,rgba(248, 200, 178, 0.5), #E77843)",
                    WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                    WebkitMaskComposite: "xor",
                    maskComposite: "exclude",
                    zIndex: -1,
                },
                "&.MuiFab-root.Mui-disabled": {
                    backgroundColor: 'transparent'
                },
                "&:hover": { backgroundColor: bgColor },
                ...sx,
            }}
        >
            {icon === "visibility" ?
                <Assets absolutePath={true} src={`/assets/img/Visibility.svg`} />
                :
                icon === "edit" ?
                    <Assets absolutePath={true} src={`/assets/img/Edit.svg`} />
                    :
                    icon === "download" ?
                        <Assets absolutePath={true} src={`/assets/img/DownloadIcon.svg`} />
                        :
                        icon === "delete" ?
                            <Assets absolutePath={true} src={`/assets/img/Delete.svg`} />
                            :
                            icon
            }
        </Fab>
    );
};

export default IconBackground;
